import { Box } from '@hivebrite/design-system/Box';

import Forum from 'hb-react/frontoffice/apps/Forum';
import { WithAppPageConfig } from 'hb-react/frontoffice/utils/WithAppPageConfig';

const TopicForumContainer = ({ topic }) => (
  <WithAppPageConfig identifier="forum">
    {({ appPageConfig }) => (
      <Box width="100%" flexDirection="column">
        <Forum
          // appPageConfig undefined if module deactivated on module store
          appPageConfig={
            appPageConfig || {
              config: {},
            }
          }
          topicName={topic.name}
        />
      </Box>
    )}
  </WithAppPageConfig>
);

export default TopicForumContainer;
